export default __webpack_public_path__ + "static/media/logo.a13123be.webp";